<template>
  <page-card>
    <template slot="header">
      <span>Select Asset</span>
    </template>
    <div slot="body">
      <el-table
        stripe
        :data="tableList"
        highlight-current-row
        style="margin-bottom:0.24rem;"
      >
        <el-table-column prop="account" label="Account">
          <template slot-scope="{ row }">{{ row.account }}</template>
        </el-table-column>
        <el-table-column prop="type" label="Type">
          <template slot-scope="{ row }">{{ row.type | dictFilter($store.getters.accountTypes)}}</template>
        </el-table-column>
        <!-- <el-table-column prop="status" label="Status" width="180">
          <template slot-scope="{ row }">{{ row.status || "--" }}</template>
        </el-table-column> -->
      </el-table>
      <el-form
        class="page-form point-form"
        ref="assetForm"
        :model="pageData"
        label-position="top"
      >
        <el-row :gutter="40">
          <el-col :span="24">
            <el-form-item
              prop="asset"
              label="Please select your asset"
              :rules="[
                { required: true, message: 'Please select', trigger: 'change' }
              ]"
            >
              <el-radio-group v-model="pageData.asset" @change="changeAsset">
                <el-radio label="1">Mineral</el-radio>
                <!-- <el-radio label="2" v-if="!isMineral">Digital (ETH , BTC)</el-radio> -->
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            :span="24"
            v-if="pageData.asset && pageData.asset.indexOf('1') > -1"
          >
            <el-form-item
              prop="region"
              label="Select region"
              :rules="[
                { required: true, message: 'Please select', trigger: 'change' }
              ]"
            >
              <el-select v-model="pageData.region" placeholder="Please select…" @change="changeRegion">
                <el-option
                  v-for="item in regionList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </page-card>
</template>

<script>
export default {
  props:["isMineral"],
  data() {
    return {
      pageData: {
        asset: "1",
        region: undefined
      },
      regionList: [
        {
          name: "CN",
          value: "CN"
        },
        {
          name: "CA",
          value: "CA"
        },
        {
          name: "HK",
          value: "HK"
        },
        {
          name: "US",
          value: "US"
        }
      ],
      tableList:[]
    };
  },
  computed: {},
  methods: {
    init() {
      if (this.$store.getters.metaMaskObj.account) {
        let item = {
          account: this.$store.getters.metaMaskObj.account,
          type: "TreasureNet",
          status: undefined
        };
        this.tableList.push(item);
      }
    },
    changeAsset(){
      this.$emit("changeAsset",this.pageData.asset);
    },
    changeRegion(){
      this.$emit("changeRegion",this.pageData.region);
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs.assetForm.validate(valid => {
          if (valid) {
            resolve(this.pageData);
          } else {
            reject();
          }
        });
      });
    }
  },
  created(){
    this.init();
  }
};
</script>
<style scoped lang="scss"></style>
